import FormEditorHeaderImage from 'routes/ReferralForm/FormEditorHeaderImage/FormEditorHeaderImage';

export default FormEditorHeaderImage;
